export class Brand {
    brandId: number;
    brandName: string;
    upcCount: number;
    createdDate: Date;

    constructor(options?: Partial<Brand>) {
        Object.assign(this, options);
    }
}
